import type { SVGProps } from 'react';
import * as React from 'react';
const SvgPressure = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}>
    <path
      d="M8 .22C3.71.22.22 3.71.22 8S3.71 15.78 8 15.78s7.78-3.49 7.78-7.78S12.29.22 8 .22m0 14.271c-3.579 0-6.491-2.912-6.491-6.491S4.421 1.509 8 1.509 14.491 4.421 14.491 8 11.579 14.491 8 14.491"
      fill="currentColor"
    />
    <path
      d="M8.385 10.389V6.555a.389.389 0 1 0-.778 0v3.834a1.254 1.254 0 0 0 .388 2.446 1.253 1.253 0 0 0 .388-2.446ZM10.23 3.773a.78.78 0 0 0-.77.777.774.774 0 1 0 1.547 0 .78.78 0 0 0-.777-.777M11.663 7.026a.777.777 0 1 0 0-1.554.777.777 0 0 0 0 1.554M8.019 4.604a.774.774 0 1 0 0-1.547.773.773 0 0 0 0 1.547M5.733 3.773a.781.781 0 0 0 0 1.562.78.78 0 0 0 0-1.562M4.306 5.456c-.423 0-.77.347-.77.777a.774.774 0 1 0 1.547 0 .776.776 0 0 0-.777-.777"
      fill="currentColor"
    />
  </svg>
);
export default SvgPressure;
